export type Theme = 'light' | 'dark';

const LIGHT_PATH_PREFIXES = ['/dashboard', '/account', '/settings', '/organization', '/internal'];

const DARK_PATH_PREFIXES = ['/public'];

const STATUS_PAGE_PREFIX = '/status/';

export const DEFAULT_THEME: Theme = 'dark';

/**
 * Returns the static theme for a given pathname when it can be resolved
 * without fetching additional data.
 */
export function getStaticThemeForPath(pathname: string): Theme | undefined {
  const normalizedPath = normalizePathname(pathname);

  if (LIGHT_PATH_PREFIXES.some((prefix) => normalizedPath.startsWith(prefix))) {
    return 'light';
  }

  if (DARK_PATH_PREFIXES.some((prefix) => normalizedPath.startsWith(prefix))) {
    return 'dark';
  }

  return undefined;
}

/**
 * Extracts the status page slug from the provided pathname, if present.
 */
export function getStatusPageSlugFromPath(pathname: string): string | null {
  const normalizedPath = normalizePathname(pathname);

  if (!normalizedPath.startsWith(STATUS_PAGE_PREFIX)) {
    return null;
  }

  const [, , slug] = normalizedPath.split('/');

  return slug?.trim() ? slug : null;
}

function normalizePathname(pathname: string): string {
  if (!pathname) return '/';

  // Strip query/hash fragments and ensure a leading slash for consistency.
  const [path] = pathname.split(/[?#]/, 1);
  if (!path) return '/';

  if (!path.startsWith('/')) {
    return `/${path}`;
  }

  return path;
}
